export var ApprovalInFlightEditRule;
(function (ApprovalInFlightEditRule) {
    /** Only approvers can edit */
    ApprovalInFlightEditRule["Approvers"] = "approvers";
    /** Everyone who has access can edit */
    ApprovalInFlightEditRule["Everyone"] = "everyone";
    /** No one can edit */
    ApprovalInFlightEditRule["Noone"] = "noone";
})(ApprovalInFlightEditRule || (ApprovalInFlightEditRule = {}));
//# sourceMappingURL=approval-in-flight-edit-rule.js.map